module.exports = __webpack_public_path__ + "img/calendar-icon.3c324d76.svg";